



































































































import Vue from "vue";
import { mapState } from "vuex";
import { DataTableHeader } from "vuetify";
import { Role } from "@/store/users";
import WaitForSuccess from "@/components/waitForSuccess.vue";
import { httpByCurrentCustomer } from "../../lib/client";
import { OrejasUser } from "../../store/users";

const headers: DataTableHeader[] = [
  {
    text: "Nombre",
    value: "name",
  },
  {
    text: "Email",
    value: "email",
  },
  {
    text: "Role",
    value: "role",
    sortable: false,
  },
  {
    text: "",
    value: "actions",
    sortable: false,
  },
];

export default Vue.extend({
  components: {
    WaitForSuccess,
  },
  data() {
    return {
      headers: Object.freeze(headers),
      showAllUsers: false,
      errorMessage: "",
      successMessage: "",
      loadingOp: false,
    };
  },
  computed: {
    ...mapState("users", { allUsers: "users" }),
    listUsers(): OrejasUser[] {
      return this.showAllUsers
        ? this.allUsers
        : (this.allUsers ?? []).filter((u: OrejasUser) => u.active);
    },
  },
  methods: {
    isSuperAdmin(user: OrejasUser): boolean {
      return this.isRole(user, "superAdmin");
    },
    isCustomerAdmin(user: OrejasUser): boolean {
      return this.isRole(user, "customerAdmin");
    },
    isCustomerUser(user: OrejasUser): boolean {
      return this.isRole(user, "customerUser");
    },
    isRole(user: OrejasUser, role: string): boolean {
      const userRoleCustomerCurrent = this.getRoleUser(user);
      if (userRoleCustomerCurrent) {
        return userRoleCustomerCurrent == role;
      }
      return false;
    },
    editUser(user: OrejasUser) {
      this.$router.push(`/users/edit/${user.id}`);
    },
    getRoleUser(user: OrejasUser): Role | undefined {
      if (user.customers.length > 0) {
        return user.customers[0].role;
      }
      return undefined;
    },
    disableUser(user: OrejasUser) {
      this.$store.dispatch("users/disableUser", user.uid);
    },
    enableUser(user: OrejasUser) {
      this.$store.dispatch("users/enableUser", user.uid);
    },
    resetUserPassword(user: OrejasUser) {
      this.loadingOp = true;
      const json = {
        email: user.email,
      };
      httpByCurrentCustomer()
        .post("users/reset", { json })
        .then(() => {
          this.successMessage =
            "Se ha enviado el correo de reestablecer contraseña.";
        })
        .catch((err) => {
          this.errorMessage = "Ocurrion un error. " + err.message;
        });
    },
    newUser() {
      this.$router.push("/users/new");
    },
    closeDialog() {
      this.successMessage = "";
      this.loadingOp = false;
      this.errorMessage = "";
    },
  },
});
